function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7811 0.175935C20.683 0.0787244 20.524 0.0787248 20.426 0.175936L11.8995 8.62952L3.37316 0.176105C3.27511 0.0788939 3.11614 0.078894 3.01809 0.176105L0.177541 2.99236C0.0794917 3.08957 0.0794914 3.24718 0.177541 3.34439L8.70387 11.7978L0.177616 20.2511C0.0795668 20.3484 0.0795668 20.506 0.177616 20.6032L3.01816 23.4194C3.11621 23.5166 3.27518 23.5166 3.37323 23.4194L11.8995 14.9661L20.4204 23.4142C20.5185 23.5114 20.6774 23.5114 20.7755 23.4142L23.616 20.5979C23.7141 20.5007 23.7141 20.3431 23.616 20.2459L15.0951 11.7978L23.6216 3.34422C23.7197 3.24701 23.7197 3.0894 23.6216 2.99219L20.7811 0.175935Z",
  fill: "#FF5982"
})));